import BaseApiRequest from "./BaseApiRequest";
import { UPDATE_APPLICANT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";
class UpdateFormRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  url = UPDATE_APPLICANT_URL;

  body = {
    formDetails: {},
  };

  constructor(formDetails, aplicationId) {
    super();
    this.body.formDetails = formDetails;
    this.url = `${UPDATE_APPLICANT_URL}${aplicationId}`;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body.formDetails;
}

export default UpdateFormRequest;
